import { useQuery } from '@tanstack/react-query';
import React from 'react';
import toast from 'react-hot-toast';
import bluetick from '../../../../assets/Logo/bluetick.png'
import "animate.css/animate.min.css";

const AllSellers = () => {

    const { data: sellers = [], refetch } = useQuery({
        queryKey: ['users'],
        queryFn: async () => {
            const res = await fetch('https://recycle-zone-server-ten.vercel.app/users?role=seller')
            const data = await res.json()
            return data;
        }
    })

    const handleDelete = (id) => {
        fetch(`https://recycle-zone-server-ten.vercel.app/users/${id}`, {
            method: 'DELETE',
        })
            .then(res => res.json())
            .then(() => {
                toast.success('Seller deleted successfully')
                refetch();
            })
    }

    const handleVerify = (id) => {
        const verify = {
            isVerified: true,
        }
        fetch(`https://recycle-zone-server-ten.vercel.app/users/${id}`, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(verify)
        })
            .then(res => res.json())
            .then(() => {
                toast.success('Seller verified successfully')
                refetch();
            })
    }

    return (
        <div className="overflow-x-auto min-h-screen">
            <table className="table w-full animate__animated animate__fadeInUpBig">
                <thead>
                    <tr>
                        <th></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Verified</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        sellers.length && sellers.map((seller, i) =>
                            <tr key={i}>
                                <th>{i + 1}</th>
                                <td className='flex items-center'>
                                    {seller.name}
                                    {
                                        seller.isVerified && <img src={bluetick} className='w-5 h-5 ml-1' alt='' />
                                    }
                                </td>
                                <td>{seller.email}</td>
                                <td>
                                    <button onClick={() => handleVerify(seller._id)} className='btn btn-sm' disabled={seller.isVerified}>
                                        {seller.isVerified ? 'Verified' : 'Verify'}
                                    </button>
                                </td>
                                <td>
                                    <button onClick={() => handleDelete(seller._id)} className='btn btn-sm btn-error'>X</button>
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    );
};

export default AllSellers;